"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SidebarContext = void 0;
var react_1 = require("react");
exports.SidebarContext = react_1.createContext({
    isExpanded: false,
});
